import { render } from "./ModalCompartilharPlanoPAP.vue?vue&type=template&id=1296fa4e"
import script from "./ModalCompartilharPlanoPAP.vue?vue&type=script&lang=js"
export * from "./ModalCompartilharPlanoPAP.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__